import { ONE, STRAPI, OTHERS } from 'config/apis'

const getStrapiImagesList = async (queryString = '') => {
  try {
    const res = await fetch(
      `${STRAPI.GALLERY_LIST}?${queryString}&pagination[pageSize]=150&populate[0]=portada`
    )
    const images = await res.json()
    return images
  } catch (err) {
    console.log(err)
  }
}

const getONEImagesList = async (queryString = '') => {
  try {
    const res = await fetch(`${ONE.MEDIA_LIST}${queryString}`, {
      ...ONE.HEADERS
    })
    const images = await res.json()
    return images.Data
  } catch (err) {
    console.log(err)
  }
}

const getStrapiImagesGallery = async (slug) => {
  try {
    const res = await fetch(STRAPI.GALLERY.replace('{slug}', slug))
    const parsed = await res.json()
    return parsed
  } catch (err) {
    console.log(err)
  }
}

const getONEImagesGallery = async (slug) => {
  try {
    const res = await fetch(ONE.GALLERY.replace('{slug}', slug), {
      ...ONE.HEADERS
    })
    const parsed = await res.json()
    return parsed
  } catch (err) {
    console.log(err)
  }
}

const getYTVideos = async ({ pageToken = '', endpoint }) => {
  try {
    const req = await fetch(
      OTHERS[endpoint].replace('{pageToken}', pageToken),
      {
        method: 'GET',
        next: { revalidate: 60 * 60 * 12 }
      }
    )
    const parsed = await req.json()
    return parsed
  } catch (err) {
    console.log(err)
  }
}

export {
  getStrapiImagesList,
  getONEImagesList,
  getStrapiImagesGallery,
  getONEImagesGallery,
  getYTVideos
}
